/// <amd-module name="TFS/Admin/Views/TeamSelector/TeamSelector" />
import React = require("react");

import { ITeamPickerItem, TeamPickerProvider } from "TeamPickerProvider";

import { ITfsPageService } from "Tfs/Platform/Page";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { Components, IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Uri } from "VSS/Platform/Util/Url";
import { ItemPickerDropdown } from "VSSUI/PickList";
import { css } from "VSSUI/Util";

/**
 * Shows a dropdown picklist of all teams for currently selected project.
 */
export class TeamSelector extends VssComponent<IVssComponentProperties> {
    private teamPickerProvider: TeamPickerProvider;
    private projectId: string;

    public constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props);

        const tfsPageService = context.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        if (tfsPageData && tfsPageData.project) {
            this.projectId = tfsPageData.project.id;
        }

        this.teamPickerProvider = new TeamPickerProvider(context.pageContext, {
            onTeamSelected: (selectedTeam: ITeamPickerItem) => {
                const uri = new Uri(window.location.href);
                uri.addQueryParam("teamId", selectedTeam.id, true);
                FastPageSwitch(context.pageContext, uri.absoluteUri, true);
            },
            projectId: this.projectId
        });
    }

    public render(): JSX.Element | null {
        return (
            <ItemPickerDropdown
                provider={this.teamPickerProvider}
                className={css("team-selector")}
                pickListClassName="team-selector-dropdown"
                hideSelectedItemIcon={true}
                onRenderSelectedItemText={(selectedItems: any[]): JSX.Element => <>{selectedItems[0].name}</>}
            />
        );
    }
}

Components.add("team-selector", TeamSelector);
